intra_module.directive('groupUnsubscribed', function() {
	return {
		restrict:    'E',
		templateUrl: 'directives/widget/group-unsubscribed/group-unsubscribed.html',
		controller:  'GroupUnsubscribedCtrl',

		scope: {
			unsubscribed: '='
		}
	};
});
